/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config"; 

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderProductDetails = { 

  async getProductUnitOfMeasure(ProductCode, BranchCode) {      
    const requestScreenData = {
      url: "api/ProductUnitOfMeasure", 
      orderBy: "ProductCode",
      // top: 1,
      expand: "Product($select=PackSize,APN)",
      filter: `ProductCode eq '${ProductCode}' and BranchCode eq '${BranchCode}'`
    }
    return await ApiService.oDataGet(requestScreenData);
  },
  async getProductUnitOfMeasureByCode(ProductCode, BranchCode, UnitOfMeasureCode) {      
    const requestScreenData = {
      url: "api/ProductUnitOfMeasure", 
      orderBy: "ProductCode",
      top: 1,
      expand: "Product($select=PackSize,APN)",
      filter: `ProductCode eq '${ProductCode}' and BranchCode eq '${BranchCode}' and UnitOfMeasureCode eq '${UnitOfMeasureCode}'`
    }
    return await ApiService.oDataGet(requestScreenData);
  },
  

};



export { SalesOrderProductDetails };
